import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios, { endpoints } from 'src/utils/axios';

const getListChat = async () => {
    const response = await axios.get(endpoints.AI.getChatAi);

    return response.data;
}

export const useListChatAi = () => {

    const listChatAiQuery = useQuery({
        queryKey: ['listChatAi' ],
        queryFn: () => getListChat(),
        staleTime: 1000 * 60 * 60 * 24,
    });

    return {
        listChatAiQuery
    };
}

const postChatAi = async (dataPayload) => {

    const { data } = await axios.post(endpoints.AI.chatAi, dataPayload);
    return data;
}

export const usePostChatAiMutation = () => {

    const queryClient = useQueryClient();

    const postChatAiMutation = useMutation({
        mutationFn: postChatAi,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['listChatAix `'] });
        },
    });

    return {
        postChatAiMutation
    };
}